import { render } from "./BackgroundParallax.vue?vue&type=template&id=64dcbc86&scoped=true&ts=true"
import script from "./BackgroundParallax.vue?vue&type=script&lang=ts"
export * from "./BackgroundParallax.vue?vue&type=script&lang=ts"

import "./BackgroundParallax.vue?vue&type=style&index=0&id=64dcbc86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dcbc86"]])

export default __exports__